<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Movimientos de medios de pago</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form>
        <div class="modal-body">
            <div class="form-group row">
                <div class="col-md-4 col-sm-4">
                    <label class="col-form-label"><b>Deducir de:</b></label>
                    <ng-select id="paymentTypes" [items]="paymentTypes" [searchable]="true" placeholder="Seleccione una metodo de pago"
                        [searchFn]="customSearch" [(ngModel)]="paymentMethodDeduct" [ngModelOptions]="{standalone: true}">
                            <ng-template ng-label-tmp let-item="item">
                                {{item.code}} - {{item.name}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <div title="{{item.code}} - {{item.name}}">{{item.code}} - {{item.name}}</div>
                            </ng-template>
                        </ng-select>
                </div>
                <div class="col-md-4 col-sm-4">
                    <label class="col-form-label"><b>Incrementar a:</b></label>
                    <ng-select id="paymentTypes" [items]="paymentTypes" [searchable]="true" placeholder="Seleccione una metodo de pago"
                        [searchFn]="customSearch" [(ngModel)]="paymentMethodIncrease" [ngModelOptions]="{standalone: true}">
                            <ng-template ng-label-tmp let-item="item">
                                {{item.code}} - {{item.name}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <div title="{{item.code}} - {{item.name}}">{{item.code}} - {{item.name}}</div>
                            </ng-template>
                        </ng-select>
                </div>
                <div class="col-md-3 col-sm-3">
                    <label class="col-form-label"><b>Cantidad en moneda a incrementar</b></label>
                    <input id="paymentMethodIncreaseAmount" [(ngModel)]="paymentMethodIncreaseAmount" [ngModelOptions]="{standalone: true}"
                            type="number" (keypress)="onlyNumbers($event)" class="form-control">
                </div>
                <div class="col-md-1 col-sm-1">
                    <br>
                    <button type="button" class="btn btn-primary pull-right" (click)="add()">Agregar</button>
                </div>
                
            </div>
            <div class="row">
                <div class="col-md-12">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Deduce</th>
                        <th scope="col">Moneda</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Incrementa</th>
                        <th scope="col">Moneda</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let paymentMethodMovement of paymentMethodMovements; let i=index">
                        <th scope="row">{{paymentMethodMovement.paymentMethodDeduct.name}}</th>
                        <td>{{paymentMethodMovement.paymentMethodDeduct.currency}}</td>
                        <td>{{paymentMethodMovement.paymentMethodDeductAmount}}</td>
                        <td>{{paymentMethodMovement.paymentMethodIncrease.name}}</td>
                        <td>{{paymentMethodMovement.paymentMethodIncrease.currency}}</td>
                        <td>{{paymentMethodMovement.paymentMethodIncreaseAmount}}</td>
                        <td><label title="Eliminar" id="" class="label label-default"><a (click)="delete(i)"><i class="fa fa-times-circle fa-2x"></i></a></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
            <button type="button" class="btn btn-outline-success" (click)="sendRequest()">Confirmar</button>
        </div>
    </form>
</div><!-- /.modal-content -->
